
import LanguageCircle from "../../../assets/duotone/LanguageCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LanguageCircleIcon({ className, dataTestid = "LanguageCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LanguageCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
